import React from "react";
import classes from './TopicCourseAssociationsModal.module.scss'

const TopicCourseAssociationsModal = ({topicCourseData}) => {
  return (
    <div className={classes.tpcCourseAssociate}>
      <div className={classes.txt}>
        This series is already associated with the below topics.You may choose
        to continue to add this program to the new topic
      </div>
      <div>
        <table>
          <tr>
            <th>Name</th>
            <th>Created On</th>
            <th>Created by</th>
          </tr>
          {topicCourseData.map((item) => {
            return (
              <tr>
                <td>{item?.Name}</td>
                <td>{item?.CreatedOn}</td>
                <td>{item?.CreatedBy}</td>
              </tr>
            );
          })}
        </table>
      </div>
    </div>
  );
};

export default TopicCourseAssociationsModal;
